import { useEffect } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

/**
 * Reusable file uploader. Accepts kind: image | doc | video | any.
 * onUploaded(url, fileMeta) => void
 */
export default function FileUploader({ kind = "any", accept, label = "Upload", onUploaded, currentUrl, testId = "file-uploader" }) {
  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post(`/admin/media/upload?kind=${kind}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Uploaded");
      onUploaded?.(data.url, data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      e.target.value = "";
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="text-xs tracking-[0.2em] uppercase font-semibold text-[#4B5563]">{label}</label>
      <div className="flex items-center gap-3 flex-wrap">
        <label
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-[#E2E8F0] bg-white hover:bg-[#F7F8F6] cursor-pointer text-sm transition-colors duration-200"
          data-testid={`${testId}-trigger`}
        >
          <input
            type="file"
            className="hidden"
            accept={accept}
            onChange={handleChange}
            data-testid={testId}
          />
          Choose file
        </label>
        {currentUrl ? (
          <a
            href={`${process.env.REACT_APP_BACKEND_URL}${currentUrl}`}
            target="_blank"
            rel="noreferrer"
            className="text-sm text-[#C2410C] underline truncate max-w-xs"
            data-testid={`${testId}-current`}
          >
            View current
          </a>
        ) : (
          <span className="text-xs text-[#4B5563]">No file uploaded</span>
        )}
      </div>
    </div>
  );
}
